import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Stack,
} from "@chakra-ui/react";
import { CreateRegistryRecordContainer } from "./CreateRegistryRecordContainer";

interface IProps {
  registryId: string;
  isOpen: boolean;
  onClose: () => void;
}

export const AddRecordModal = ({ registryId, onClose, isOpen }: IProps) => {
  const handleOnClose = () => {
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleOnClose}
      closeOnOverlayClick={true}
      size="3xl"
      scrollBehavior="inside"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Add Record</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Stack spacing={4}>
            <CreateRegistryRecordContainer
              registryId={registryId}
              onClose={handleOnClose}
            ></CreateRegistryRecordContainer>

            {/* {isErrorCreateRegistry && (
              <Alert status="error" variant={"solid"}>
                <AlertIcon />
                <Text>Failed to create new registry, please refresh</Text>
              </Alert>
            )} */}
          </Stack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
